import { Slide, TextProps } from '@features/powerpoint';
import { NAVIGATING_COMPLEXITY_SLIDE } from '../utils';
import { theme } from '../domain/theme';

const TITLE_FONT_SIZE = 40;
const BODY_FONT_SIZE = 16;
const LABEL_FONT_SIZE = 9;

const labelText = (
  text: string,
  options: NonNullable<TextProps['options']> = {}
): TextProps => ({
  text,
  options: {
    h: 0.25,
    w: 2.84,
    fontSize: LABEL_FONT_SIZE,
    color: theme.colors.lightGray,
    ...options,
  },
});

export const navigatingComplexitySlide = (): Slide => {
  return {
    slideMaster: NAVIGATING_COMPLEXITY_SLIDE,
    texts: [
      {
        text: [
          {
            text: 'Navigating ',
            options: {
              fontSize: TITLE_FONT_SIZE,
              color: theme.colors.inmarketGreen,
              bold: true,
            },
          },
          {
            text: 'Complexity',
            options: {
              fontSize: TITLE_FONT_SIZE,
              color: theme.colors.white,
            },
          },
        ],
        options: {
          h: 0.77,
          w: 7.03,
          x: 0.44,
          y: 2.93,
          charSpacing: -1.5,
        },
      },
      {
        text: [
          {
            text: 'Technology and analytics are more complex than ever.',
            options: {
              fontSize: BODY_FONT_SIZE,
              color: theme.colors.white,
              breakLine: true,
            },
          },
          {
            text: 'InMarket simplifies measurement and optimization.',
            options: {
              fontSize: BODY_FONT_SIZE,
              color: theme.colors.white,
              breakLine: true,
            },
          },
          {
            text: 'Is your media driving incremental growth?',
            options: {
              fontSize: BODY_FONT_SIZE,
              color: theme.colors.white,
              bold: true,
            },
          },
        ],
        options: {
          h: 1.16,
          w: 9.03,
          x: 0.46,
          y: 3.68,
          paraSpaceAfter: 8,
        },
      },
      labelText('Omnichannel content', {
        x: 6.58,
        y: 1.26,
      }),
      labelText('Data granularity', {
        w: 3.47,
        x: 9.33,
        y: 1.65,
      }),
      labelText('Online to offline consumer journeys', {
        w: 2.51,
        x: 5.12,
        y: 1.95,
      }),
      labelText('Contextual\naudiences', {
        h: 0.4,
        x: 7.91,
        y: 2.92,
      }),
      labelText('Increase\nROAS', {
        h: 0.4,
        x: 9.7,
        y: 2.87,
      }),
      labelText('Platform evolution', {
        x: 7.39,
        y: 4.22,
      }),
      labelText('Market penetration', {
        x: 9.68,
        y: 4.52,
      }),
      labelText('Privacy concerns', {
        x: 7.82,
        y: 5.15,
      }),
      labelText('Dynamic content', {
        x: 6.57,
        y: 5.68,
      }),
      labelText('Cross platform\nmeasurement', {
        h: 0.4,
        x: 8.91,
        y: 5.87,
      }),
      labelText('Quality insights', {
        x: 7.7,
        y: 6.47,
      }),
      labelText('Incrementality', {
        x: 9.89,
        y: 6.54,
      }),
    ],
  };
};
